<template>
	<div class="interactionSetBar">
		<div class="setItem">
			<div class="label">收货地址</div>
			<el-tooltip
				popper-class="interactionToolTip"
				effect="dark"
				content="开启后，用户领取实物奖品时需填写收货地址"
				placement="bottom-start"
			>
				<i class="iconfont icon-bangzhushuoming"></i>
			</el-tooltip>
			<el-switch v-model="physicalAddress" active-color="#165DFF" :active-value="1" :inactive-value="0" />
		</div>
		<div class="setItem">
			<div class="label">短信验证</div>
			<el-tooltip popper-class="interactionToolTip" effect="dark" placement="bottom-start">
				<div slot="content">
					开启后，用户领取实物奖品时需验证手机号。<br />注：成功发送短信后将扣除短信包中的对应条<br />数，短信包余额不足时将无法使用该功能，为<br />保证活动正常进行请确保短信包余额充足
				</div>
				<i class="iconfont icon-bangzhushuoming"></i>
			</el-tooltip>
			<el-switch v-model="physicalSmsCheck" active-color="#165DFF" :active-value="1" :inactive-value="0" />
		</div>
		<sms-assets />
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
	inject: ['saveSetting'],
	data() {
		return {
			id: parseInt(this.$route.params.id),
		};
	},
	computed: {
		...mapState({
			currentActive: (state) => state.state.currentActive,
		}),
		...mapGetters({
			haveSmsAssets: 'haveSmsAssets',
		}),
		physicalAddress: {
			get() {
				return (
					this.currentActive &&
					this.currentActive.iconSwitchShow &&
					this.currentActive.iconSwitchShow.physicalAddress
				);
			},
			set(val) {
				if (this.currentActive && this.currentActive.iconSwitchShow && this.currentActive.id) {
					console.log('======', this.currentActive, { physicalAddress: val });
					this.saveSetting({ physicalAddress: val });
				}
			},
		},
		physicalSmsCheck: {
			get() {
				return (
					this.currentActive &&
					this.currentActive.iconSwitchShow &&
					this.currentActive.iconSwitchShow.physicalSmsCheck
				);
			},
			set(val) {
				if (val) {
					if (!this.haveSmsAssets) {
						this.$root.$emit('smsDialogShow');
						return;
					}
				}
				if (this.currentActive && this.currentActive.iconSwitchShow && this.currentActive.id) {
					this.saveSetting({ physicalSmsCheck: val });
				}
			},
		},
	},
};
</script>

<style lang="less" scoped>
.interactionSetBar {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #1d2129;
	line-height: 20px;
	.setItem {
		display: flex;
		align-items: center;
		.iconfont {
			cursor: pointer;
			font-size: 14px;
			color: #4e5969;
			margin-left: 6px;
		}
		.el-switch {
			margin-left: 16px;
		}
		& + .setItem {
			margin-left: 32px;
		}
	}
	.smsAssets {
		margin-left: 16px;
	}
}
</style>
<style>
.interactionToolTip {
	margin-left: -6px;
}
</style>
